import React, { useState, useEffect } from "react";
import useWindowDimensions from "../../../../../../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import { colors } from "../../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../../common-components";
import MovementCard from "./components/movement-card/MovementCard";
import TransferPopUp from "./components/transfer-pop-up/TransferPopUp";

const TransferKeyPopUp = ({
  display,
  onCloseClick,

  data,
  auth,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  setRefresh,
  refresh,
}) => {
  const { width, height } = useWindowDimensions();
  const [selectedUser, setSelectedUser] = useState(null);
  const [note, setNote] = useState("");

  const [keyHistory, setKeyHistor] = useState(false);
  const [keyHistoryArray, setKeyHistoryArray] = useState([]);

  const [linkedUsersAray, setLinkedUsersArray] = useState([]);

  const [keyTransferPop, setKeyTransferPop] = useState(false);

  const getUserVehicleList = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userInvites/getlinkedUsers",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: data ? data.vehicleOwnerUuid : null,
          }),
        }
      );

      const respnseData = await response.json();
      if (!respnseData.error) {
        setLinkedUsersArray(respnseData.linkedUsers);
        // setToastPop(true);
      }
    } catch (err) {}
  };
  const CreateTransferKeyRequest = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userVehicles/tranferKeyRequest",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: data ? data.vehicleOwnerUuid : null,
            note: note !== "" ? note : "nothing",
            vheicleId: data ? data._id : null,
            keyTransferById: auth ? auth.userId : null,
            keyTransferToId: selectedUser.invitedUserId,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setLoading(false);
        setMessage(respnseData.success);
        setToastPop(true);
        setPopUpTitle("SUCCESS");
        setRefresh(refresh ? false : true);
        setSelectedUser(null);
        setKeyTransferPop(false);
        // setKeyHistoryArray(respnseData.vehicleHistory);
        // setToastPop(true);
      } else {
        setLoading(false);
        setMessage(respnseData.error);
        setToastPop(true);
        setPopUpTitle("FAILURE");
      }
    } catch (err) {
      setMessage("CHECK YOUR NETWORK CONNECTION");
      setToastPop(true);
      setPopUpTitle("FAILURE");
      setLoading(false);
    }
  };
  const getKeyHistory = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL +
          "/userVehicles/getKeyHistoryFprVehicle",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            vehicleId: data ? data._id : null,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setKeyHistoryArray(respnseData.vehicleHistory);
        // setToastPop(true);
      }
    } catch (err) {}
  };
  useEffect(() => {
    if (data) {
      getKeyHistory();
    }
  }, [data]);
  useEffect(() => {
    if (data) {
      getUserVehicleList();
    }
  }, [data]);
  return (
    <div
      style={{
        position: "absolute",
        minWidth: display ? 400 : 0,
        width: display ? 400 : 0,
        minHeight: height - 60,
        height: height - 60,
        backgroundColor: colors.white,
        right: 0,
        zIndex: 20000,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        WebkitBoxShadow: "0px 0px 7px 2px #00000030",
      }}
    >
      <div style={{ position: "absolute", top: 10, left: 10 }}>
        <BaseButtons
          label={"X"}
          backgroundColor={colors.orangeDark}
          borderRadius={8}
          onClick={onCloseClick}
          width={40}
        />
      </div>
      <div
        style={{
          minHeight: 60,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          fontWeight: "bold",
          fontSize: 18,
        }}
      >
        KEY TRANSFERS
      </div>
      <div
        style={{
          width: "100%",

          minHeight: 40,
          marginTop: 10,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: keyHistory ? colors.white : "#000000",
        }}
      >
        <BaseButtons
          onClick={() => setKeyTransferPop(true)}
          label={"TRANSFER KEY"}
          backgroundColor={keyTransferPop ? colors.white : colors.greenLight}
          color={keyTransferPop ? colors.greenDark : colors.white}
          borderRadius={8}
          width={"90%"}
        />
      </div>
      <div
        style={{
          width: "100%",

          minHeight: 40,
          marginTop: 10,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: keyHistory ? colors.white : "#000000",
        }}
      >
        <BaseButtons
          onClick={() => setKeyHistor(keyHistory ? false : true)}
          label={" KEY MOVEMENT HISTORY"}
          backgroundColor={keyHistory ? colors.white : colors.greenLight}
          color={keyHistory ? colors.greenDark : colors.white}
          borderRadius={8}
          width={"90%"}
        />
      </div>
      {keyHistory ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {keyHistoryArray.length >= 1
            ? keyHistoryArray.map((key, index) => {
                return (
                  <div key={index} style={{ width: "100%" }}>
                    <MovementCard
                      username={key.vehicleOwnerId}
                      transferredFrom={key.transferredBy}
                      dateRecieved={key.dateRecieved}
                      contactInfo={key.vehicleDriverContactInfo}
                    />
                  </div>
                );
              })
            : null}
        </div>
      ) : null}
      <TransferPopUp
        data={data}
        display={keyTransferPop}
        setKeyTransferPop={setKeyTransferPop}
        auth={auth}
        setLoading={setLoading}
        setMessage={setMessage}
        setPopUpTitle={setPopUpTitle}
        setToastPop={setToastPop}
        setRefresh={setRefresh}
        refresh={refresh}
      />
    </div>
  );
};

export default TransferKeyPopUp;
